import {Component, Injectable, inject, computed, signal, effect, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {ReturnConditionsRestService} from "./return-conditions.rest";
import {ReturnConditionData} from "../models/return.condition.data";
import {ResponseModel} from "../../../core/base/response.model";
import {UserService} from "../../../core/user/services/user.service";

@Injectable({
  providedIn: 'root'
})

export class ReturnConditionsService {
 private returnConditionsResatService = inject(ReturnConditionsRestService)
  private readonly destroyRef = inject(DestroyRef);
  private userService = inject(UserService);

  private _conditions = signal<ReturnConditionData | null>(null);
  readonly conditions = this._conditions.asReadonly();
  readonly hasConditions = computed(() => this._conditions() !== null);

  constructor() {
    effect(() => {
      const idf = this.userService.selectedIdf();
      if(idf) {
        this.loadConditions(idf);
      }
    });
  }

  private loadConditions(idf: string): void {
    this.returnConditionsResatService.loadReturnConditions(idf).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: ResponseModel) => {
          if (response.return_object) {
            this._conditions.set(new ReturnConditionData(response.return_object));
          } else {
            this._conditions.set(null);
          }
        },
        error: (error: any) => {
          console.error('Error loading return conditions:', error);
        }
      });
  }

}
